import { Form, Select } from 'antd';
import React, { useEffect } from 'react';

const BooleanDrop = ({
    label,
    name,
    disabled,
    required,
    errorMessage,
    defaultValue,
    form,
    bg= '#ffffff',
    placeHolder
}) => {

    useEffect(() => {
        form.setFieldsValue({ [name]: defaultValue });
    }, []);

    return (
        <Form.Item
            wrapperCol={!label ? { span: 24 } : undefined}
            // initialValue={defaultValue ? defaultValue : null}
            labelCol={{ span: 8 }}
            name={name}
            label={label}
            style={{ marginRight: "10px", fontWeight: 600, background: bg }}
            rules={[
                {
                    required: required,
                    message: errorMessage,
                },
            ]}
        >
            <Select
                disabled={disabled}
                placeholder={placeHolder}
                options={[
                    { label: 'True', value: true },
                    { label: 'False', value: false }
                ]}
            />
        </Form.Item>
    )
};

export default BooleanDrop;